let primeResolveEpoch = 0;

/** Bumped when interactive reads start so list priming stops immediately. */
export function cancelBackgroundResolvePriming(): number {
  primeResolveEpoch += 1;
  return primeResolveEpoch;
}

export function currentBackgroundResolvePrimingEpoch(): number {
  return primeResolveEpoch;
}

/** @internal Test helper. */
export function resetBackgroundResolvePrimingForTests(): void {
  primeResolveEpoch = 0;
}
